const CUSTOM_SENSOR_GET = 'CUSTOM_SENSOR/GET';
const CUSTOM_SENSOR_RESET = 'CUSTOM_SENSOR/RESET';

export { CUSTOM_SENSOR_GET, CUSTOM_SENSOR_RESET };
